// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"dd3b1015","57":"80fcfe94","92":"bef722ea","438":"2fadc25f","453":"333072f4","487":"c4b011ec","635":"6ce6b98e","691":"d5fcd7c7"}[chunkId] + ".chunk.js";
};